export default {
  methods: {
    getProcessLogData(params) {
      return this.$api.get('admin/robot_logs', params)
        .then(({ data }) => {
          return data
        })
        .catch(() => null)
    },

    getProcessLogList(params) {
      return this.$api.get('admin/robot_logs/name_list', params)
        .then(({ data }) => {
          return data
        })
        .catch(error => Promise.reject(error))
    }
  }
}
